import {
  Avatar,
  Button,
  Container,
  Flex,
  Heading,
  Link,
  Separator,
  Stack,
} from "@chakra-ui/react";
import { useSession } from "../hooks/useSession";
import { Link as ReactRouterLink } from "react-router-dom";
import { FakturLogo } from "./FakturLogo";

export const Navbar = () => {
  const { data } = useSession({ redirectWhenUnauthorized: false });
  const isLoggedIn = Boolean(data?.email);

  return (
    <Container maxW="100%" p={0}>
      <Container maxW="container.lg" px={8}>
        <Flex justifyContent="space-between" alignItems="center" height="4rem">
          <Link asChild>
            <ReactRouterLink to={isLoggedIn ? "/invoices" : "/"}>
              <Stack direction="row" gap={2} alignItems="center">
                <FakturLogo size={28} />
                <Heading size="sm">FAKTUR.NO</Heading>
              </Stack>
            </ReactRouterLink>
          </Link>
          {isLoggedIn && (
            <Stack direction="row" gap={4}>
              <Link asChild>
                <ReactRouterLink to="/invoices">
                  <Heading size="sm">Fakturaer</Heading>
                </ReactRouterLink>
              </Link>
              <Link asChild>
                <ReactRouterLink to="/customers">
                  <Heading size="sm">Kunder</Heading>
                </ReactRouterLink>
              </Link>
            </Stack>
          )}
          {isLoggedIn && (
            <Link asChild>
              <ReactRouterLink to="/profile/">
                <Avatar.Root size="sm">
                  <Avatar.Fallback />
                </Avatar.Root>
              </ReactRouterLink>
            </Link>
          )}
          {!isLoggedIn && (
            <Link asChild>
              <ReactRouterLink to="/auth/login">
                <Button>Logg inn</Button>
              </ReactRouterLink>
            </Link>
          )}
        </Flex>
      </Container>
      <Separator />
    </Container>
  );
};
